import { Module } from 'vuex';
import IRootState from '@/store/types/IRootState';
import IContactState from './types/IContactState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const contact: Module<IContactState, IRootState> = {
  namespaced: true,
  state: {
    meta: {
      title: '',
      description: '',
    },
    header: {
      title: '',
      description: '',
      image: '',
    },
    team: [],
  },
  actions,
  getters,
  mutations,
};

export default contact;
